import { gql } from '@apollo/client';

export const GET_ACCOUNT = gql`
  {
    currentUser @client {
      id
      firstName
      lastName
      email
      phone
      countryId
      accountStatusId
      status
      onboardingStatus
      legacyClaim
      primaryAccountId
      roles {
        id
        code
      }
    }
  }
`;

export const GET_USER_STATUS = gql`
  {
    isVerified @client
  }
`;

export const GET_USER_STEP = gql`
  {
    onboardingStep @client
  }
`;

export const SET_USER_STEP = gql`
  mutation setOnboardingStep($onboardingStep: String) {
    setOnboardingStep(onboardingStep: $onboardingStep) @client
  }
`;

export const GET_RETURNING_USER_ROLES = gql`
  {
    returningUserRoles @client
  }
`;

export const GET_MAPPED_PROFILES = gql`
  {
    mappedProfiles @client {
      data {
        artist {
          id
          firstName
          lastName
          primaryArtistId
          hasPersonalProfile
          sortOrder
        }
        profiles
        selectedProfile {
          id
          artistId
          divisionId
        }
      }
    }
  }
`;

export const SET_MAPPED_PROFILES = gql`
  mutation setMappedProfiles($mappedArtists: Array) {
    setMappedProfiles(data: $mappedArtists) @client
  }
`;

export const GET_ARTISTS = gql`
  {
    artists @client {
      id
      firstName
      lastName
      hasPersonalProfile
      primaryArtistId
      sortOrder
    }
  }
`;

export const SET_ARTISTS = gql`
  mutation setArtists($artists: Array) {
    setArtists(artists: $artists) @client
  }
`;

export const SET_CURRENT_USER = gql`
  mutation setCurrentUser($currentUser: gqlBauAccount) {
    setCurrentUser(currentUser: $currentUser) @client
  }
`;

export const GET_USERNAME = gql`
  {
    currentUsername @client
  }
`;

export const GET_PRIMARY_ACCOUNT_ID = gql`
  {
    primaryAccountId @client
  }
`;

export const MUTATION_LOGIN = gql`
  mutation bauLogin($username: String!, $password: String!, $instance: String!, $migratedAccountID: Float!) {
    bauLogin(
      input: { username: $username, password: $password, instance: $instance, migratedAccountID: $migratedAccountID }
    )
  }
`;

export const GET_USERNAME_API = gql`
  {
    currentUser {
      legacyLogin
    }
  }
`;

export const GET_USER = gql`
  query currentUser {
    currentUser {
      id
      firstName
      lastName
      email
      phone
      countryId
      accountStatusId
      status
      hasPreMappedOrg
      onboardingStatus
      legacyClaim
      legacyLogin
      primaryAccountId
      roles {
        id
        code
      }
    }
  }
`;

export const GET_ALL_DMAS = gql`
  query dmas {
    dmas {
      id
      name
      region {
        country {
          id
          name
        }
      }
    }
  }
`;

export const GET_COUNTRIES = gql`
  query getBauCountries {
    getBauCountries {
      name
      id
      code
      hasState
      hasDma
      supportingCountryId
    }
  }
`;

export const MUTATION_RESEND_EMAIL = gql`
  mutation resentVerificationEmail($audience: String!) {
    resentVerificationEmail(audience: $audience)
  }
`;

export const MUTATION_UPDATE_EMAIL = gql`
  mutation updateBauEmailAddress($email: String!, $audience: String!) {
    updateBauEmailAddress(email: $email, audience: $audience)
  }
`;

export const VERIFY_TOKEN = gql`
  mutation verifyBauAccount($token: String!) {
    verifyBauAccount(token: $token)
  }
`;

export const GET_PROFILES = gql`
  query getProfileByLegacyPersonId {
    getProfileByLegacyPersonId {
      id
      legacyProfileId
      stageName
      divisionName
      divisionId
      artistId
      status {
        id
        code
      }
      primaryWorkingLocationId
      primaryWorkingLocationName
      playableMaxAge
      playableMinAge
      dateOfBirth
      talentUnions {
        id
        code
        name
        enabled
        sortOrder
      }
      medias {
        id
        guid
        mediaId
        filename
        height
        width
        mediaFileKey
      }
      weight {
        lbs
        kg
      }
      height {
        inch
        imperial
        cm
      }
    }
  }
`;

export const GET_WORKING_LOCATIONS = gql`
  query dmas($isLimitedOnly: Boolean) {
    dmas(isLimitedOnly: $isLimitedOnly) {
      id
      name
      code
      enabled
      sortOrder
      region {
        id
        name
        code
        country {
          id
          code
          name
          continent {
            id
          }
        }
      }
    }
  }
`;

export const GET_DMAS_INFO = gql`
  query dmas($input: FilterInput) {
    dmas(input: $input) {
      id
      code
      name
    }
  }
`;

export const GET_ETHNIC_APPEARANCES = gql`
  query ethnicAppearances {
    ethnicAppearances {
      id
      name
      code
      sortOrder
    }
  }
`;

export const UPDATE_LEGACY_PROFILE = gql`
  mutation updateLegacyProfile($input: BauProfileUpdateInput!) {
    updateLegacyProfile(input: $input) {
      status
      token {
        access
        refresh
      }
    }
  }
`;

export const GET_BAU_EXISTING_ARTISTS = gql`
  query artistByBauAccount {
    artistByBauAccount {
      artistId: id
      firstName
      lastName
      profiles {
        profileId: id
        isPersonal
      }
    }
  }
`;

export const SET_UPDATE_LEGACY_PROFILE_TOKEN = gql`
  mutation setUpdateLegacyProfileToken($updateLegacyProfileToken: gqlAuthTokenItem) {
    setUpdateLegacyProfileToken(updateLegacyProfileToken: $updateLegacyProfileToken) @client
  }
`;

export const GET_UPDATE_LEGACY_PROFILE_TOKEN = gql`
  {
    updateLegacyProfileToken @client {
      access
      refresh
    }
  }
`;

export const GET_USER_COUNTRY = gql`
  query countries($keys: [ID!]!) {
    countries(input: { keys: $keys, keyType: id }) {
      unitSystem {
        id
        code
        name
      }
    }
  }
`;
